
import { defineComponent } from "vue";

export default defineComponent({
  name: "kt-quick-links-menu",
  components: {}
});
